import { type UseQueryResult, useQuery } from 'react-query';
import {
  TaxCertificationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO,
} from '../../services/wealthlane-customer-services';

/**
 * Hook to fetch the latest tax certification form (W8 or W9) for prepopulating recertification forms.
 * This is used when a participant recertifies their tax form to prepopulate all fields except SSN/TIN.
 */
const useGetLatestTaxCertificationForm = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean = true
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO | undefined,
  unknown
> => {
  const latestTaxCertificationForm = useQuery(
    ['getLatestTaxCertificationForm'],
    async () => {
      return await handleRequest(
        TaxCertificationService.getApiCustomerApiAppTaxCertificationLatestTaxCertificationForm()
      );
    },
    {
      enabled,
      cacheTime: 1000 * 60 * 5, // Cache for 5 minutes
      staleTime: 1000 * 60 * 2, // Data becomes stale after 2 minutes
    }
  );

  return latestTaxCertificationForm;
};

export default useGetLatestTaxCertificationForm;

